import { Place } from '../../../types/state';
import { sportingAPI } from '../api';
import { normalizeSportingPlace } from '../utils/normalizeSportingPlace';

export const getPlaces = async (): Promise<Place[]> => {
  const places = await sportingAPI.booking.getPlaces();

  return places.map(normalizeSportingPlace.toPlace);
};
